'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Shelves = require('./Shelves');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Shelves).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Shelves/index.js
// module id = 1288
// module chunks = 1